class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-questions").click(function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.next().slideUp(350);

          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-plus")
            .css({ display: "flex" });
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-minus")
            .css({ display: "none" });
        } else {
          $this.parent().parent().find(".faq-answers").removeClass("show");
          $this.parent().parent().find(".faq-answers").slideUp(350);

          $this
            .parent()
            .parent()
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-plus")
            .css({ display: "flex" });
          $this
            .parent()
            .parent()
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-minus")
            .css({ display: "none" });

          $this.next().toggleClass("show");
          $this.next().slideToggle(350);

          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-plus")
            .css({ display: "none" });
          $this
            .find(".fa-chevron-arrows")
            .find(".fa-chevron-minus")
            .css({ display: "flex" });
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section", FaqSection);

class CustomReviews extends HTMLElement {
  constructor() {
   super();
  }

  connectedCallback() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
      this.swiper = new Swiper(
      ".custom-review-block-container-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next_" + this.getAttribute("data-sectionid"),
            prevEl: ".swiper-button-prev_" + this.getAttribute("data-sectionid"),
          },
        });  
    };
  
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-reviews", CustomReviews);

class CustomCollectionAutoplay extends HTMLElement {
  constructor() {
   super();
  }

  connectedCallback() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
      $(".custom-new-tag").mouseenter(function(){
        $('.firstproductimage').show();
        $('.secondproductimage').hide();
        
        $(this).find('.firstproductimage').hide();
        $(this).find('.secondproductimage').show();

        $('.custom-collection-product-info').hide()
        $(this).find('.custom-collection-product-info').show()
      });

    
      $(".custom-new-tag").mouseleave(function(){
        $('.firstproductimage').show();
        $('.secondproductimage').hide();
        $('.custom-collection-product-info').hide()
      });

    $(window).resize(function() {
    if (window.matchMedia('(max-width: 767px)').matches){
      
      $(".custom-new-tag").click(function(){
        $('.firstproductimage').show();
        $('.secondproductimage').hide();
        
        $(this).find('.firstproductimage').hide();
        $(this).find('.secondproductimage').show();

        $('.custom-collection-product-info').hide()
        $(this).find('.custom-collection-product-info').show()
      });

      $(".custom-new-tag").on('tap',function () {
        $('.firstproductimage').show();
        $('.secondproductimage').hide();
        
        $(this).find('.firstproductimage').hide();
        $(this).find('.secondproductimage').show();

        $('.custom-collection-product-info').hide()
        $(this).find('.custom-collection-product-info').show()
      });
    }
    });

    };
  
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-collection-autoplay", CustomCollectionAutoplay);

class CustomContentWithButtons extends HTMLElement {
  constructor() {
   super();
  }

  connectedCallback() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    $(this).css({"opacity":"1"});
    
    function isiPhone() {
      return /iPhone/i.test(navigator.userAgent);}

    function isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    }

    function isAndroid() {
      return /Android/i.test(navigator.userAgent);
    }
        if (isiPhone()) {
           $('.custom-button-direction-ios').show();
           $('.custom-button-direction-android').hide();
        } else if (isMac()) {
            $('.custom-button-direction-ios').show();
            $('.custom-button-direction-android').hide();
        } else if (isAndroid()) {
          $('.custom-button-direction-ios').hide();
          $('.custom-button-direction-android').show();
        } else {
           $('.custom-button-direction-ios').hide();
           $('.custom-button-direction-android').show();
        }


    };
  
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-content-with-buttons", CustomContentWithButtons);


class CustomSliderFade extends HTMLElement {
  constructor() {
   super();
  }

  connectedCallback() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
      var delay = $(this).data('delay');
      var autoplay = $(this).data('autoplay');
      this.swiper = new Swiper(
      ".custom-fade-slider-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          effect: "fade",
          autoplay: {
            enabled:autoplay,
            delay: delay,
            disableOnInteraction: false,
          },
          fadeEffect: { crossFade: true },
          virtualTranslate: true,
        });  
    };
  
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-slider-fade", CustomSliderFade);


// class countdowntimer extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);
// console.log('dfbgiudfbgiudfgdfngdfgofd');
//       var month = $(this).data("month");
//       var date = $(this).data("date");
//       var year = $(this).data("year");
//       var time = $(this).data("time");
//       var counttime = month + date + ','+ year + time;
//         window.onload = function () {
//       var controller = new AbortController();
//       var countDownDate = new Date(counttime).getTime();
//       var clockDaysElement = document.querySelector(".clock-days");
//       var clockHoursElement = document.querySelector(".clock-hours");
//       var clockMinutesElement = document.querySelector(".clock-minutes");
//       var clockSecondsElement = document.querySelector(".clock-seconds");
//       // Create an animation callback every second:
//       animationInterval(1000, controller.signal, (time) => {
//         // Get today's date and time
//         let now = new Date().getTime();

//         // Find the distance between now and the count down date
//         let distance = countDownDate - now;

//         // Time calculations for days, hours, minutes and seconds
//         let days = Math.floor(distance / (1000 * 60 * 60 * 24));
//         let hours = Math.floor(
//           (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
//         );
//         let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//         let seconds = Math.floor((distance % (1000 * 60)) / 1000);

//         // Display the results
//         clockDaysElement.textContent = days;
//         clockHoursElement.textContent = hours;
//         clockMinutesElement.textContent = minutes;
//         clockSecondsElement.textContent = seconds;

//         // If any of the units are negative, mark as expired
//         if (days < 0 || hours < 0 || minutes < 0 || seconds < 0) {
//           controller.abort();
//           $('.countdown-container').css({"display":"none"});
//         }
//       });
//     };

//   function animationInterval(ms, signal, callback) {
//       // Prefer currentTime, as it'll better sync animtions queued in the
//       // same frame, but if it isn't supported, performance.now() is fine.
//       const start = document.timeline
//         ? document.timeline.currentTime
//         : performance.now();

//       function frame(time) {
//         if (signal.aborted) return;
//         callback(time);
//         scheduleFrame(time);
//       }

//       function scheduleFrame(time) {
//         const elapsed = time - start;
//         const roundedElapsed = Math.round(elapsed / ms) * ms;
//         const targetNext = start + roundedElapsed + ms;
//         const delay = targetNext - performance.now();
//         setTimeout(() => requestAnimationFrame(frame), delay);
//       }

//       scheduleFrame(start);
//   }
      
//     };

//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }
// customElements.define("countdown-timer", countdowntimer);

